import { render } from "./FlowPageList.vue?vue&type=template&id=2bffadd6&scoped=true"
import script from "./FlowPageList.vue?vue&type=script&lang=js"
export * from "./FlowPageList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2bffadd6"

export default script